module.exports = __webpack_public_path__ + "img/luckdraw_stop.b2222ef7.png";